// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1___06109a8ee8b763380f6","cls2":"PaperImages-cls2__e3669717681d076201f6 PaperImages-cls1___06109a8ee8b763380f6"};